import React from "react";

const LocationFormFields = ({ location, disabled, onChange }) => (
  <React.Fragment>
    <div className="form-group">
      <label className="control-label" htmlFor="location">
        Lokasjon
      </label>
      <input
        onChange={e => onChange(["location", "name"], e.target.value)}
        id="location"
        name="location"
        type="text"
        placeholder="Navn/Adresse"
        value={location.name}
        className="form-control input-md"
        disabled={disabled}
      />
    </div>
  </React.Fragment>
);

export default LocationFormFields;



// WEBPACK FOOTER //
// ./src/components/LocationFormFields.js